import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";

export const Reveal = ({ children, variants = fadeUp, className, delay = 0, ...rest }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      variants={variants}
      transition={delay ? { delay } : undefined}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
